import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Container, Typography } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import LingerieFixTool from '../components/photoTools/LingerieFixTool'

const PhotoLingerieFixPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="Popraw modelkę w bieliźnie"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Popraw modelkę w bieliźnie
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Tryb 1: Cover (SAM3: bra/panties/torso) → Strawberry Pro → Uncover. Tryb 2: Keep-only (SAM3: face/head/hands/feet) → Strawberry Pro → Apply. Tryb 3: Cover (czarne prostokąty) → Strawberry Pro → Uncover.
          </Typography>
        </Box>

        <LingerieFixTool />
      </Container>
    </>
  )
}

export default PhotoLingerieFixPage
